module.exports = __webpack_public_path__ + "img/card_active.367c22a1.svg";